module.exports = __webpack_public_path__ + "img/Flag_of_Italy.80b5f2ae.svg";